export default __webpack_public_path__ + "dc60fc9.png";